import { Option } from "../../util/option";
import { ErrorMessage } from "../../util/spreadsheet-data-utils";
import { EdhPrtclAndPjtInfo } from "../component-detail";

export type EdhProtocolAttributePageState = {
  edhPrtclInfo: EdhPrtclInfo[];
  generalCode: GeneralCode;
  isSaved: boolean;
  isEdited: boolean;
};

export type SpreadsheetState = {
  edhPrtclInfo: EdhPrtclInfo[];
  generalCode: GeneralCode;
  editCell: EditCell;
};

export type EdhPrtclInfo = {
  idx: number;
  isCommentEdit: boolean;
  editedAttributeListInfo: EditedAttributeListInfo[];
  isRequest: boolean;
  action: string;
  edhPrtclAttributeList: EdhPrtclAndPjtInfo;

  // For ErrorInfo
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};
export type EditedAttributeListInfo = {
  index: number;
  env: string;
};
export type GeneralCode = {
  reviewingActionType: Option[];
  designCompletedActionType: Option[];
  inDefCommonFlagType: Option[];
};
export type EditCell = {
  [key: string]: {
    isDirty: boolean;
    isError: boolean;
    initialValue: string;
    currentValue: string;
  };
};
export type PageNewState =
  | EdhProtocolAttributePageState
  | ((
      prevState: EdhProtocolAttributePageState,
    ) => EdhProtocolAttributePageState);
